import axiosClient from "../axiosClient";
import {
  CREATE_PURCHASE_FROM_PUBLIC_CHARGES,
  CREATE_PURCHASE_FROM_PUBLIC_COMMISSION_URL,
  CREATE_PURCHASE_FROM_PUBLIC_DETAILS_URL,
  CREATE_PURCHASE_FROM_PUBLIC_DOCUMENT_URL,
  CREATE_PURCHASE_FROM_PUBLIC_INFORMATION_URL,
  CREATE_PURCHASE_FROM_PUBLIC_PAYMENT_URL,
  CREATE_PURCHASE_FROM_PUBLIC_SUSPICIOUSTRANSACTION,
  CREATE_SALE_TO_PUBLIC_COMMISSION_URL,
  CREATE_SALE_TO_PUBLIC_DOC_URL,
  CREATE_SALE_TO_PUBLIC_PAYMENT_URL,
  CREATE_SALE_TO_PUBLIC_URL,
  DELETE_SALE_TO_PUBLIC_URL,
  GET_PURCHASE_FROM_PUBLIC_ALL_INFO,
  GET_PURCHASE_FROM_PUBLIC_CHARGES_BY_ID,
  GET_PURCHASE_FROM_PUBLIC_GETALL,
  GET_PURCHASE_FROM_PUBLIC_OTHER_CHARGES,
  GET_PURCHASE_FROM_PUBLIC_PREVIOUS_TRANSACTION,
  CREATE_SALE_TO_PUBLIC_DETAIL_URL,
  GETALL_SALE_TO_PUBLIC_URL,
  GETBYID_SALE_TO_PUBLIC_URL,
  UPDATE_SALE_TO_PUBLIC_URL,
  DOWNLOAD_SALE_TO_PUBLIC_DOC_URL,
  HISTORY_SALE_TO_PUBLIC_URL,
  DELETE_SALE_TO_PUBLIC_DOC_URL,
  UPDATE_SALE_TO_PUBLIC_DOC_URL,
  PAYMENT_SALE_TO_PUBLIC_URL,
  CHARGES_SALE_TO_PUBLIC_URL,
  CREATE_CHARGES_SALE_TO_PUBLIC_URL,
  GET_PURCHASE_FROM_PUBLIC_DOCUMENT_DOWNLOAD,
  GETALL_CURRENCYSTOCK_URL,
  GET_CURRENCYSTOCK_PRINT,
  GETALL_VTCIn_URL,
  GETBYID_VTCIn,
  CREATE_VTCInInfo_URL,
  CREATE_VTCInDetail_URL,
  GETALL_VTCOut_URL,
  GETBYID_VTCOut,
  CREATE_VTCOutInfo_URL,
  CREATE_VTCOutDetail_URL,
  DELETE_PURCHASE_FROM_PUBLIC_DOCUMENT_DELETE,
  GET_PURCHASE_FROM_PUBLIC_INVOICE,
  GET_SALE_TO_PUBLIC_INVOICE,
  CREATE_SURRENDER_EVTMINFO_URL,
  CREATE_SURRENDER_EVTMDETAILS_URL,
  CREATE_SURRENDER_EVTMPAYMENTS_URL,
  GETBYID_SURRENDER_EVTM_URL,
  GETALL_SURRENDER_EVTMINFO_URL,
  GETALL_SETTLEMENT_VTM,
  CREATE_EVTM_SETTLEMENT_INFO,
  CREATE_EVTM_SETTLEMENT_DETAIL,
  CREATE_EVTM_SETTLEMENT_PAYMENT,
  GET_EVTM_SETTLEMENT_BY_ID,
  GET_SALES_DETAILS_BY_CARD_NO,
  GET_PURCHASE_DETAILS_BY_CARD_NO,
  UPDATE_PURCHASE_FROM_PUBLIC_DOCUMENT_UPDATE,
  GETALL_CURRENCY_OUT_URL,
  GETINFOBYID_CURRENCY_OUT_URL,
  CREATE_CURRENCY_OUT_URL,
  UPDATE_CURRENCY_OUT_STATUS_URL,
  GETALL_PURCHASE_INVOICE_URL,
  GET_DOWNLOAD_PURCHASE_INVOICE,
  CREATE_PURCHASE_INVOICE_INFO,
  CREATE_PURCHASE_INVOICE_DETAIL,
  CREATE_PURCHASE_INVOICE_PAYMENT,
  CREATE_UPDATE_PURCHASE_INVOICE_DOCUMENT,
  CREATE_PURCHASE_INVOICE_DOCUMENT,
  GETBYID_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE_DOCUMENT,
  GET_SALE_TO_PUBLIC_INVOICE_SALES,
  GETALL_SALE_INVOICE_URL,
  GETBYID_SALE_INVOICE,
  GET_DOWNLOAD_SALE_INVOICE_UPLOAD,
  CREATE_SALE_INVOICE_INFO,
  CREATE_SALE_INVOICE_DETAIL,
  CREATE_SALE_INVOICE_PAYMENT,
  CREATE_SALE_INVOICE_DOCUMENT,
  UPDATE_SALE_INVOICE_DOCUMENT,
  DELETE_SALE_INVOICE_DOCUMENT,
  GET_SALE_INVOICE_COMMON_CHARGE,
  GET_PURCHASE_INVOICE_COMMON_CHARGE,
  GET_SALE_TO_PUBLIC_A2FORM,
  GET_SALE_TO_PUBLIC_LRSFORM,
  GET_BILL_PRINT,
  GET_ALL_BILL_PRINT,
  GET_SALE_TO_PUBLIC_LRS_PREV_TRANS,
  CREATE_CDF_PURCHASE_FROM_PUBLIC,
  UPDATE_CDF_PURCHASE_FROM_PUBLIC,
  DOWNLOAD_CDF_PURCHASE_FROM_PUBLIC,
  DELETE_CDF_PURCHASE_FROM_PUBLIC,
  CREATE_SALE_ENCASHMENT,
  UPDATE_SALE_ENCASHMENT,
  DOWNLOAD_SALE_ENCASHMENT,
  DELETE_SALE_ENCASHMENT,
} from "../endpoints";

export const SaletoPublicService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_SALE_TO_PUBLIC_URL);
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_TO_PUBLIC_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  update: async (updateData: any) => {
    try {
      const params = new URLSearchParams({
        ID: updateData.id ?? "",
        TypeName: updateData.typeName ?? "",
        ProductTypeId: updateData.productTypeId ?? "",
        ISD: updateData.isd ?? "",
        CurrencyId: updateData.currencyId ?? "",
        IssuerId: "01JKDD1WDP3KMEYPH2H6F3D06B",
        AgeLimit: String(updateData.ageLimit ?? "0"),
      })?.toString();
      const response = await axiosClient.put(
        `${UPDATE_SALE_TO_PUBLIC_URL}?${params}`
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Update failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_SALE_TO_PUBLIC_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Deletion failed");
    }
  },
  getbyId: async (SalesId: string) => {
    try {
      const response = await axiosClient.get(GETBYID_SALE_TO_PUBLIC_URL, {
        params: { SalesId }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  history: async (TravellerId: string) => {
    try {
      const response = await axiosClient.get(HISTORY_SALE_TO_PUBLIC_URL, {
        params: { TravellerId }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  lrshistory: async (TravellerId: string, FinancialYr: string) => {
    try {
      const response = await axiosClient.get(
        GET_SALE_TO_PUBLIC_LRS_PREV_TRANS,
        {
          params: { TravellerId, FinancialYr }, // Use 'data' for the request payload
        }
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching lrs history:", error);
      throw new Error("Loading failed");
    }
  },
  totalcharge: async (SalesId: string) => {
    try {
      const response = await axiosClient.get(PAYMENT_SALE_TO_PUBLIC_URL, {
        params: { SalesId }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  a2form: async (SalesId: string) => {
    try {
      const response = await axiosClient.get(GET_SALE_TO_PUBLIC_A2FORM, {
        params: { SalesId }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  lrsform: async (SalesId: string) => {
    try {
      const response = await axiosClient.get(GET_SALE_TO_PUBLIC_LRSFORM, {
        params: { SalesId }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
};

export const PurchaseFromPublicInformation = {
  create: async (createPurchase: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_FROM_PUBLIC_INFORMATION_URL,
        createPurchase
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      return error;
    }
  },
};

export const PurchaseFromPublicDetail = {
  create: async (createPurchase: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_FROM_PUBLIC_DETAILS_URL,
        createPurchase
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Purchase Failed to Create");
    }
  },
};
export const PurchaseFromPublicCommission = {
  create: async (createPurchase: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_FROM_PUBLIC_COMMISSION_URL,
        createPurchase
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Purchase Failed to Create");
    }
  },
};
export const PurchaseFromPublicPayment = {
  create: async (createPurchase: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_FROM_PUBLIC_PAYMENT_URL,
        createPurchase
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      
    }
  },
};
export const PurchaseFromPublicDocument = {
  create: async (createPurchase: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_FROM_PUBLIC_DOCUMENT_URL,
        createPurchase
      );

      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Purchase Failed to Create");
    }
  },
  update: async (updatePurchase: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_PURCHASE_FROM_PUBLIC_DOCUMENT_UPDATE,
        updatePurchase
      );

      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Purchase Failed to Create");
    }
  },

  download: async (id: string) => {
    try {
      const response = await axiosClient.get(
        `${GET_PURCHASE_FROM_PUBLIC_DOCUMENT_DOWNLOAD}/${id}`
      );

      return {
        data: response.data,
        headers: response.headers,
        config: response.config,
      };
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      console.log(error, "kkk");

      throw new Error("Document Download Failed");
    }
  },

  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(
        DELETE_PURCHASE_FROM_PUBLIC_DOCUMENT_DELETE,
        { params: { id } }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Deletion failed");
    }
  },
};
export const PurchaseFromPublicCDF = {
  create: async (createPurchase: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_CDF_PURCHASE_FROM_PUBLIC,
        createPurchase
      );

      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Purchase Failed to Create");
    }
  },
  update: async (updatePurchase: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_CDF_PURCHASE_FROM_PUBLIC,
        updatePurchase
      );

      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Purchase Failed to Create");
    }
  },

  download: async (id: string) => {
    try {
      const response = await axiosClient.get(
        `${DOWNLOAD_CDF_PURCHASE_FROM_PUBLIC}/${id}`
      );

      return {
        data: response.data,
        headers: response.headers,
        config: response.config,
      };
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      console.log(error, "kkk");

      throw new Error("Document Download Failed");
    }
  },

  delete: async (PurchaseId: string) => {
    try {
      const response = await axiosClient.delete(
        DELETE_CDF_PURCHASE_FROM_PUBLIC,
        { params: { PurchaseId } }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Deletion failed");
    }
  },
};
export const SaletoPublicDetailService = {
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_TO_PUBLIC_DETAIL_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
};
export const SaletoPublicCommissionService = {
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_TO_PUBLIC_COMMISSION_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
};
export const SaletoPublicPaymentService = {
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_TO_PUBLIC_PAYMENT_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
     
      throw new Error("Creation failed");
    }
  },
};
export const SaletoPublicOtherCharges = {
  create: async (SalesId: string) => {
    try {
      const response = await axiosClient.post(
        CREATE_CHARGES_SALE_TO_PUBLIC_URL,
        {
          SalesId, // Use 'data' for the request payload
        }
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  getall: async (SalesId: string) => {
    try {
      const response = await axiosClient.get(CHARGES_SALE_TO_PUBLIC_URL, {
        params: { SalesId }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
};
export const SaletoPublicDocService = {
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_TO_PUBLIC_DOC_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  update: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_SALE_TO_PUBLIC_DOC_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  download: async (SaleFileId: string) => {
    try {
      const response = await axiosClient.get(
        `${DOWNLOAD_SALE_TO_PUBLIC_DOC_URL}/${SaleFileId}`,
        {
          responseType: "blob", // Required for file downloads
        }
      );
      return { data: response.data, headers: response.headers }; // Ensure both data & headers are returned
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      console.error("Download failed:", error);
      throw new Error("Loading failed");
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_SALE_TO_PUBLIC_DOC_URL, {
        params: { id }, // Use 'data' for the request payload
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Deletion failed");
    }
  },
};

export const SaleToPublicInvoice = {
  get: async (SalesId: string) => {
    try {
      const response = await axiosClient.get(GET_SALE_TO_PUBLIC_INVOICE, {
        params: { SalesId },
      });
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Failed to Get Invoice Data");
    }
  },
  getbysales: async (SalesId: string) => {
    try {
      const response = await axiosClient.get(GET_SALE_TO_PUBLIC_INVOICE_SALES, {
        params: { SalesId },
      });
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Failed to Get Invoice Data");
    }
  },
};

export const PurchasefromSuspiciousTransaction = {
  create: async (createPurchase: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_FROM_PUBLIC_SUSPICIOUSTRANSACTION,
        createPurchase
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Suspicious Transaction Failed to Create");
    }
  },
};
export const PurchasePreviousTransaction = {
  get: async (TravellerId: any) => {
    try {
      const response = await axiosClient.get(
        GET_PURCHASE_FROM_PUBLIC_PREVIOUS_TRANSACTION,
        { params: { TravellerId } }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Failed to get Previous Transaction");
    }
  },
};
export const PurchaseFromPublicOtherCharges = {
  get: async (PurchaseId: any) => {
    try {
      const response = await axiosClient.get(
        GET_PURCHASE_FROM_PUBLIC_OTHER_CHARGES,
        { params: { PurchaseId } }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Failed to fetch Other Charges");
    }
  },
};
export const PurchaseFromPublicGetAll = {
  getAll: async () => {
    try {
      const response = await axiosClient.get(GET_PURCHASE_FROM_PUBLIC_GETALL);
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw error; // Rethrow the original error to propagate it
    }
  },
};
export const PurchaseFromPublicGetAllInfo = {
  getAll: async (purchaseId: string) => {
    try {
      const response = await axiosClient.get(
        GET_PURCHASE_FROM_PUBLIC_ALL_INFO,
        {
          params: { purchaseId },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Failed to Get Purchase Information");
    }
  },
};
export const PurchaseFromPublicCharges = {
  create: async (purchaseId: string) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_FROM_PUBLIC_CHARGES,
        { purchaseId: purchaseId }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Failed to create Charges");
    }
  },
  get: async (purchaseId: string) => {
    try {
      const response = await axiosClient.get(
        GET_PURCHASE_FROM_PUBLIC_CHARGES_BY_ID,
        { params: { purchaseId } }
      );
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Failed to Get Charges Information");
    }
  },
};
export const CurrencyStockServices = {
  getAll: async (FinancialYear: string) => {
    try {
      const response = await axiosClient.get(GETALL_CURRENCYSTOCK_URL, {
        params: { FinancialYear },
      });
      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Failed to Fetch");
    }
  },
  getPrint: async (FinancialYear: number | null, BranchId: string) => {
    try {
      const response = await axiosClient.get(GET_CURRENCYSTOCK_PRINT, {
        params: { FinancialYear, BranchId },
      });

      return response.data;
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Failed to Fetch");
    }
  },
};

export const vtcInService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_VTCIn_URL);
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  getbyId: async (Id: string) => {
    try {
      const response = await axiosClient.post(`${GETBYID_VTCIn}?Id=${Id}`);
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  createInfo: async (createData: any) => {
    try {
      const response = await axiosClient.post(CREATE_VTCInInfo_URL, createData);
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  createDetail: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_VTCInDetail_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
};
export const vtcOutService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_VTCOut_URL);
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  getbyId: async (Id: string) => {
    try {
      const response = await axiosClient.post(`${GETBYID_VTCOut}?Id=${Id}`);
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  createInfo: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_VTCOutInfo_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  createDetail: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_VTCOutDetail_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
};
export const PurchaseFromPublicInvoice = {
  get: async (PurchaseId: string) => {
    try {
      const response = await axiosClient.get(GET_PURCHASE_FROM_PUBLIC_INVOICE, {
        params: { PurchaseId },
      });
      return response.data;
    } catch (error) {
      return error;
      throw new Error("Failed to Get Invoice Data");
    }
  },
};
//EvtmSurrender
export const EvtmSurrenderService = {
  createInfo: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SURRENDER_EVTMINFO_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  createDetails: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SURRENDER_EVTMDETAILS_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  createPayments: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SURRENDER_EVTMPAYMENTS_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  getById: async (id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_SURRENDER_EVTM_URL, {
        params: { id },
      });
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  getAllInfo: async () => {
    try {
      const response = await axiosClient.get(GETALL_SURRENDER_EVTMINFO_URL);
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);

      throw new Error("Loading failed");
    }
  },
};
//VtmSettlementInfo
export const EvtmSettlementService = {
  getAll: async () => {
    try {
      const response = await axiosClient.get(GETALL_SETTLEMENT_VTM);
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  createInfo: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_EVTM_SETTLEMENT_INFO,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  createDetail: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_EVTM_SETTLEMENT_DETAIL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  createPayment: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_EVTM_SETTLEMENT_PAYMENT,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Creation failed");
    }
  },
  getById: async (id: string) => {
    try {
      const response = await axiosClient.get(GET_EVTM_SETTLEMENT_BY_ID, {
        params: { id },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
export const vtmDetailsGetByCardNo = {
  getSalesByCardNo: async (CardNo: string) => {
    try {
      const response = await axiosClient.get(GET_SALES_DETAILS_BY_CARD_NO, {
        params: { CardNo },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
  getPurchaseByCardNo: async (CardNo: string) => {
    try {
      const response = await axiosClient.get(GET_PURCHASE_DETAILS_BY_CARD_NO, {
        params: { CardNo },
      });
      return response.data; // Returns response data
    } catch (error) {
      throw new Error("Loading failed");
    }
  },
};
export const CurrencyOutService = {
  getall: async () => {
    try {
      const response = await axiosClient.get(GETALL_CURRENCY_OUT_URL);
      console.log(response.data, "currency out");

      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  getbyId: async (Id: string) => {
    try {
      const response = await axiosClient.post(
        `${GETINFOBYID_CURRENCY_OUT_URL}?Id=${Id}`
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Loading failed");
    }
  },
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_CURRENCY_OUT_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
  status: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_CURRENCY_OUT_STATUS_URL,
        createData
      );
      return response.data; // Returns response data
    } catch (error) {
      console.error("Error occurred while fetching other charges:", error);
      throw new Error("Creation failed");
    }
  },
};

export const PurchaseInvoiceService = {
  getAll: async () => {
    try {
      const response = await axiosClient.get(GETALL_PURCHASE_INVOICE_URL);
      return response.data;
    } catch (error) {
      throw new Error("GET SERVICE FAILED");
    }
  },
  getById: async (Id: string) => {
    try {
      const response = await axiosClient.get(GETBYID_PURCHASE_INVOICE, {
        params: { Id },
      });
      return response.data;
    } catch (error) {
      throw new Error("GET INVOICE BY ID FAILED");
    }
  },
  download: async (id: string) => {
    try {
      const response = await axiosClient.get(
        `${GET_DOWNLOAD_PURCHASE_INVOICE}/${id}`
      );
      return {
        data: response.data,
        headers: response.headers,
        config: response.config,
      };
    } catch (error) {
      throw new Error("INVOICE DOWNLOAD API FAILED");
    }
  },
  createInfo: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_INVOICE_INFO,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  createDetail: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_INVOICE_DETAIL,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  createPayment: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_INVOICE_PAYMENT,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  createDocument: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_PURCHASE_INVOICE_DOCUMENT,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("CREATE UPLOAD SERVICE FAILED");
    }
  },
  updateDocument: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_UPDATE_PURCHASE_INVOICE_DOCUMENT,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  deleteDocument: async (Id: string) => {
    try {
      const response = await axiosClient.delete(
        DELETE_PURCHASE_INVOICE_DOCUMENT,
        { params: { Id } }
      );
      return response.data;
    } catch (error) {
      throw new Error("DELETE INVOICE FAILED");
    }
  },
  getCharges: async (PurchaseId: string) => {
    try {
      const response = await axiosClient.get(
        GET_PURCHASE_INVOICE_COMMON_CHARGE,
        { params: { PurchaseId } }
      );
      return response.data;
    } catch (error) {
      throw new Error("FETCH PURCHAE INVOICE COMMON CHARGE FAILED");
    }
  },
};

export const SaleInvoiceService = {
  getAll: async () => {
    try {
      const response = await axiosClient.get(GETALL_SALE_INVOICE_URL);
      return response.data;
    } catch (error) {
      throw new Error("GET SERVICE FAILED");
    }
  },
  getById: async (SaleId: string) => {
    try {
      const response = await axiosClient.get(GETBYID_SALE_INVOICE, {
        params: { SaleId },
      });
      return response.data;
    } catch (error) {
      throw new Error("GET INVOICE BY ID FAILED");
    }
  },
  download: async (SaleDocumentFileName: string) => {
    try {
      const response = await axiosClient.get(
        `${GET_DOWNLOAD_SALE_INVOICE_UPLOAD}/${SaleDocumentFileName}`
      );
      return {
        data: response.data,
        headers: response.headers,
        config: response.config,
      };
    } catch (error) {
      throw new Error("INVOICE DOWNLOAD API FAILED");
    }
  },
  createInfo: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_INVOICE_INFO,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  createDetail: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_INVOICE_DETAIL,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  createPayment: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_INVOICE_PAYMENT,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  createDocument: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_INVOICE_DOCUMENT,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("CREATE UPLOAD SERVICE FAILED");
    }
  },
  updateDocument: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_SALE_INVOICE_DOCUMENT,
        createData
      );
      return response.data;
    } catch (error) {
      throw new Error("INVOICE INFO FORM CREATE FAILED");
    }
  },
  deleteDocument: async (Id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_SALE_INVOICE_DOCUMENT, {
        params: { Id },
      });
      return response.data;
    } catch (error) {
      throw new Error("DELETE INVOICE FAILED");
    }
  },
  getCharge: async (SaleId: string) => {
    try {
      const response = await axiosClient.get(GET_SALE_INVOICE_COMMON_CHARGE, {
        params: { SaleId },
      });
      return response.data;
    } catch (error) {
      throw new Error("GET INVOICE COMMON CHARGE FAILED");
    }
  },
};

export const BillPrintingService = {
  get: async (postData: any) => {
    try {
      const response = await axiosClient.get(GET_BILL_PRINT, {
        params: postData,
      });
      return response.data;
    } catch (error) {
      throw new Error("GET BILL PRINT FAILED");
    }
  },
  getAll: async (postData: any) => {
    try {
      const response = await axiosClient.get(GET_ALL_BILL_PRINT, {
        params: postData,
      });
      return response.data;
    } catch (error) {
      throw new Error("GET ALL BILL PRINT FAILED");
    }
  },
};

export const SaleEncashmentCertificateService = {
  create: async (createData: any) => {
    try {
      const response = await axiosClient.post(
        CREATE_SALE_ENCASHMENT,
        createData
      );
      return response.data;
    } catch (error) {
     throw new Error("Encashment Create Failed")
    }
  },
  update: async (updateData: any) => {
    try {
      const response = await axiosClient.post(
        UPDATE_SALE_ENCASHMENT,
        updateData
      );
      return response.data;
    } catch (error) {
     throw new Error("Encashment Update Failed")
    }
  },
  delete: async (id: string) => {
    try {
      const response = await axiosClient.delete(DELETE_SALE_ENCASHMENT, {
        params: { id },
      });
      return response;
    } catch (error) {
     throw new Error("Encashment Delete Failed")
    }
  },
  download: async (fileName: string) => {
    try {
      const response = await axiosClient.get(
        `${DOWNLOAD_SALE_ENCASHMENT}/${fileName}`
      );
      return {
        data: response.data,
        headers: response.headers,
        config: response.config,
      };
    } catch (error) {
     throw new Error("Encashment Download Failed")
    }
  },
};
